<template>
  <div class="container-order-info">
    <h4 class="container-order-info__main-title">{{ $t('order.order_payment') }}</h4>

    <div class="row">
      <div class="col-12">
        <CheckBoxComponent @onClick="onIsInvoiceNeededToggle($event)"
                           :state="isInvoiceNeeded"
                           id="isInvoiceNeeded"
                           name="isInvoiceNeeded"
                           class="checkbox-default"
        >
          <template #checkbox-text>
            <label for="isInvoiceNeeded">
              {{ $t('order.is_invoice_needed') }}
            </label>
          </template>
        </CheckBoxComponent>
      </div>
    </div>

    <div class="payment-methods__container mt-4">
      <div class="payment-methods__item" v-for="paymentMethod in paymentMethods"
           v-on:click="onPaymentMethodSelect(paymentMethod)">
        <div class="payment-methods__radio-btn" :class="{'selected': paymentMethod.selected}">
          <div class="payment-methods__radio-btn__bubble"></div>
        </div>
        <div class="w-100 text-center d-flex align-items-center justify-content-center">
          <img v-if="paymentMethod.logoUrl" v-bind:src="paymentMethod.logoUrl" :title="paymentMethod.title">
          <span v-if="paymentMethod.titleNextToLogo" class="ms-2"><b>{{ $t(paymentMethod.titleNextToLogo) }}</b></span>

          <span v-if="!paymentMethod.logoUrl">{{ paymentMethod.title }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import './rentOrderInfo.scss';

import {defineComponent} from "vue";
import type {PropType} from "vue";

//@ts-ignore
import CheckBoxComponent from "../../../components/CheckBox/CheckBoxComponent.vue";
import type {IPaymentMethod} from "@/interfaces/IPaymentMethod.interface";
import {useStore} from "vuex";

export default defineComponent({
  name: 'OrderChoosePaymentComponent',
  components: {
    CheckBoxComponent
  },
  props: {
    paymentMethodsProp: {
      type: Array as PropType<IPaymentMethod[]>,
      required: true
    }
  },
  setup() {
    const store = useStore();

    return {
      store,
      isInvoiceNeeded: store.state.order.isInvoiceNeeded,
    }
  },
  data: () => {
    return {
      paymentMethods: <IPaymentMethod[]>[],
      isInvoiceNeeded: false,
    };
  },
  watch: {
    paymentMethodsProp(newVal, oldVal): void {
      const currentPaymentMethodKey = this.store.state.order.paymentMethod;

      let arr = [...newVal];

      if (currentPaymentMethodKey) {
        arr = arr.map((item: IPaymentMethod) => {
          return {...item, selected: item.key === currentPaymentMethodKey};
        });
      }

      this.paymentMethods = arr;
    }
  },
  methods: {
    onIsInvoiceNeededToggle($event): void {
      this.isInvoiceNeeded = !this.isInvoiceNeeded;

      this.store.dispatch('order/updateIsInvoiceNeeded', this.isInvoiceNeeded);
    },
    onPaymentMethodSelect(paymentMethod: IPaymentMethod): void {
      this.paymentMethods = this.paymentMethods.map((item) => {
        return {...item, selected: item.key === paymentMethod.key};
      });

      this.store.dispatch('order/updatePaymentMethod', paymentMethod);
    }
  }
})

</script>


<style lang="scss">
.payment-methods {
  &__container {
    display: flex;
    align-items: baseline;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    gap: 10px 20px;
    row-gap: 10px;
    column-gap: 20px;
  }

  &__item {
    border: 1px solid #dedede;
    border-radius: 24px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    width: 218px;
    height: 80px;

    @media (max-width: 767px) {
      width: 100%;
    }

    &:hover {
      cursor: pointer;

      .payment-methods__radio-btn {
        border-color: #0046fa;
      }
    }
  }

  &__radio-btn {
    margin-right: 15px;
    border-radius: 50%;
    border: 2px solid #dedede;
    padding: 10px;
    position: relative;

    &.selected {
      border-color: #0046fa;

      .payment-methods__radio-btn__bubble {
        background: #0046fa;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

</style>